import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import ReactTooltip from 'react-tooltip';
import CopyButton from "../../../../../components/CopyButton";
import { _AgentRowWrapper, _SidebarStudentIcon, _HighlightedText, _TooltipList } from "../../styles";
import { BottomText } from "../../../../../components/style/CommonStyles";
var AgentRow = function AgentRow(_ref) {
  var agent_name = _ref.agent_name,
    agent = _ref.agent;
  return /*#__PURE__*/React.createElement(_AgentRowWrapper, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    "data-tip": "Recruitment Partner Id"
  }, /*#__PURE__*/React.createElement("span", null, agent.id), /*#__PURE__*/React.createElement("span", null, "|")), /*#__PURE__*/React.createElement("a", {
    href: agent.link
  }, agent_name), agent && agent.admin_comments && /*#__PURE__*/React.createElement(_SidebarStudentIcon, {
    status: "warning"
  }, /*#__PURE__*/React.createElement(ReactTooltip, {
    multiline: true,
    id: "tooltipWrapper"
  }, /*#__PURE__*/React.createElement(_TooltipList, null, agent.admin_comments.map(function (c) {
    return /*#__PURE__*/React.createElement("li", {
      key: c.id
    }, c.description);
  }))), /*#__PURE__*/React.createElement("span", {
    "data-for": "tooltipWrapper",
    "data-tip": true
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "exclamation-triangle"
  }))), agent_name !== 'Name not available' && /*#__PURE__*/React.createElement(CopyButton, {
    label: agent_name,
    dataCy: "copy-agent-name",
    tooltip: "Click to copy recruitment partner's name",
    successMessage: "Copied recruitment partner's name to clipboard"
  }), agent && agent.vip_text && /*#__PURE__*/React.createElement(BottomText, null, /*#__PURE__*/React.createElement(_HighlightedText, null, "Proirity Recruitment Partner Notes: ", agent.vip_text))));
};
export default AgentRow;